function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.47,201.41s-1.78,4-4.27,9.08l0,0c-4.32,8.86-13.39,20.78-30.69,19.91-28.14-2.23-36.37-33.87-36.37-33.87s.55-12.56-5.61-16.74-13.4-48-13.4-48l21.16-35.71,21.08,7.7,29.27,10.72,9.92,7.24.53,15.64-11.26,12.27s3.45,27.66,2.15,36.83C356.78,194.89,375.47,201.41,375.47,201.41Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Plants--inject-32--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.36,406.29c-.06,0,1.2-4.06,1.31-4.3,1.26-2.85,5.41-7.63,8.85-7.26a4.13,4.13,0,0,1,3.55,4.65,3,3,0,0,1-.08.43c-.5,2.42-2.91,4.27-5,5.27C445.5,406.24,439.36,406.29,439.36,406.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701,359.87c-2.5-1.09-6.58-5.68-6.59-5.69s3.84-1.75,4.1-1.84c3-.93,9.27-1,11.29,1.88a4.13,4.13,0,0,1-1.15,5.72,2.5,2.5,0,0,1-.39.23C706.11,361.39,703.14,360.8,701,359.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.5,385.44c-1.55,1.11-3,2.18-4.24,3.16l-2.38-.64c1.61-1.21,3.5-2.55,5.57-4,1.21-.84,2.52-1.72,3.88-2.6a41.89,41.89,0,0,1-1.62-4.34c-2.31.13-6.59-1.25-7.14-1.42-.55,1.35-1.06,2.66-1.53,3.92-1.07,2.82-1.93,5.35-2.64,7.49l-2-.53c.77-2.18,1.72-4.75,2.87-7.63.55-1.37,1.16-2.83,1.8-4.31-.5-.32-4.56-2.92-5.8-4.8-1.12-1.71-2.07-4.22-1.33-6.26a3.62,3.62,0,0,1,4.57-2.34l.36.13c2.77,1.33,3.66,6.79,3.29,9.51,0,.15-.45,1.87-.73,2.94.27-.62.51-1.19.79-1.81.55-1.25,1.13-2.45,1.73-3.77l1-1.88c.3-.61.72-1.26,1.09-1.9.87-1.48,1.82-2.92,2.82-4.35-1.08-.49-4.89-2.26-6.26-3.78s-2.68-3.86-2.27-6a3.64,3.64,0,0,1,4.14-3.05c.14,0,.28.05.41.09,2.94.89,4.62,6.17,4.7,8.9,0,.17-.19,2.14-.31,3.22.61-.86,1.21-1.72,1.85-2.56,1.85-2.46,3.79-4.88,5.72-7.3l1.76-2.24c-.39-.16-5-2.17-6.5-3.87-1.36-1.53-2.68-3.86-2.27-6A3.65,3.65,0,0,1,642,334.4c.13,0,.27.05.4.09,2.94.89,4.62,6.17,4.7,8.9,0,.2-.27,3-.37,3.76,1.29-1.64,2.55-3.29,3.73-5a63.92,63.92,0,0,0,4.38-7.06c-.19-.05-5-2.14-6.54-3.89-1.36-1.52-2.68-3.84-2.27-6a3.64,3.64,0,0,1,4.16-3,2.7,2.7,0,0,1,.39.08c2.94.89,4.62,6.17,4.69,8.9,0,.18-.19,2.34-.31,3.37l.17,0a47,47,0,0,0,3-7.76c.45-1.47.79-2.9,1.1-4.3-.93-.29-5.14-1.68-6.75-3.11s-3.09-3.53-2.91-5.7a3.63,3.63,0,0,1,3.81-3.45l.39,0c3,.56,5.29,5.61,5.64,8.33,0,.14,0,1.67,0,2.78.13-.63.27-1.29.39-1.89.42-2.29.67-4.4.87-6.28q.16-1.61.24-2.94c-.75-.76-3.78-3.88-4.53-5.85s-1.11-4.55,0-6.38a3.63,3.63,0,0,1,5-1.32l.33.21c2.42,1.89,2.11,7.42,1.17,10-.06.22-1.76,3.55-1.8,3.51h0c0,.87-.09,1.8-.18,2.82-.16,1.89-.39,4-.74,6.32a65.94,65.94,0,0,1-1.56,7.36,47.42,47.42,0,0,1-2.87,7.92l0,.1c.62-.66,2.4-2.43,2.55-2.55,2.15-1.72,7.3-3.75,9.85-2a3.62,3.62,0,0,1,.88,5.06l-.24.31c-1.38,1.68-4,2.13-6.06,2.05-2.31-.09-6.78-2.35-7.13-2.53a66.07,66.07,0,0,1-4.35,7.4c-.94,1.38-1.92,2.75-2.92,4.11.55-.55,1-1,1.12-1.1,2.14-1.71,7.29-3.75,9.85-2a3.63,3.63,0,0,1,.88,5.06,2.42,2.42,0,0,1-.25.31c-1.37,1.68-4,2.14-6,2.06s-5.93-1.93-6.94-2.43c-.4.51-.78,1-1.17,1.54-1.88,2.47-3.76,4.93-5.53,7.4-.62.87-1.18,1.77-1.79,2.62l1-1c2.14-1.71,7.29-3.75,9.85-2a3.64,3.64,0,0,1,.88,5.06,3.92,3.92,0,0,1-.25.32c-1.37,1.67-4,2.13-6,2s-5.55-1.76-6.75-2.35c-.58.92-1.16,1.84-1.67,2.75-.33.61-.71,1.21-1,1.87l-.94,1.91c-.56,1.25-1.13,2.49-1.64,3.71-.36.84-.69,1.65-1,2.46.6-.87,1.84-2.55,2-2.68a14.15,14.15,0,0,1,6.14-3.61,3.86,3.86,0,0,1,.6-.54,3.62,3.62,0,0,1,5.1.56,3.71,3.71,0,0,1,.23.32c1.58,2.63-.7,7.67-2.5,9.74-.1.13-1.4,1.31-2.24,2,.56-.36,1.09-.71,1.69-1.07,1.14-.73,2.29-1.42,3.53-2.16l1.86-1c.61-.35,1.3-.65,1.95-1,1.55-.74,3.14-1.42,4.77-2.06-.63-1-2.82-4.58-3.1-6.6s-.12-4.69,1.41-6.24a3.63,3.63,0,0,1,5.13-.2l.27.28c2,2.36.48,7.69-1,10-.09.14-1.33,1.69-2,2.52,1-.39,1.95-.77,2.95-1.13,2.89-1,5.85-2,8.8-2.92l2.7-.9c-.23-.35-3-4.54-3.27-6.82-.3-2-.12-4.69,1.4-6.23a3.64,3.64,0,0,1,5.14-.2l.27.27c2,2.37.48,7.7-1,10-.11.17-1.9,2.39-2.38,2.93,2-.66,3.94-1.34,5.85-2.08a66,66,0,0,0,7.54-3.47c-.11-.17-3-4.53-3.29-6.86-.3-2-.12-4.69,1.4-6.24a3.64,3.64,0,0,1,5.14-.2,3.45,3.45,0,0,1,.26.28c2,2.36.48,7.7-1,10-.1.15-1.46,1.85-2.12,2.63l.11.14a45.67,45.67,0,0,0,6.83-4.81c1.18-1,2.26-2,3.29-3-.62-.76-3.38-4.26-3.92-6.32s-.63-4.65.71-6.36a3.64,3.64,0,0,1,5.08-.77,2.43,2.43,0,0,1,.3.24c2.22,2.14,1.32,7.6.12,10.06,0,.14-.89,1.42-1.5,2.35.46-.45,1-.91,1.37-1.36,1.61-1.66,3-3.3,4.19-4.75.68-.84,1.28-1.6,1.82-2.31-.21-1.06-1-5.33-.55-7.38s1.58-4.41,3.56-5.33a3.65,3.65,0,0,1,4.88,1.66c.05.12.1.23.14.35,1,2.91-2.32,7.35-4.56,9-.18.14-3.42,2-3.43,1.94l0-.06c-.51.71-1.09,1.46-1.7,2.26-1.18,1.49-2.52,3.15-4.13,4.86a65.25,65.25,0,0,1-5.37,5.28,47.5,47.5,0,0,1-6.79,5l-.08,0c.87-.21,3.34-.71,3.54-.73,2.73-.24,8.16.91,9.34,3.73a3.62,3.62,0,0,1-2.06,4.7l-.38.13c-2.07.64-4.52-.43-6.18-1.62-1.87-1.36-4.35-5.71-4.55-6.05a65.35,65.35,0,0,1-7.71,3.76c-1.58.63-3.14,1.25-4.7,1.82a10.37,10.37,0,0,1,1.54-.28c2.73-.24,8.16.91,9.34,3.73a3.62,3.62,0,0,1-2.06,4.7l-.38.13c-2.07.64-4.51-.43-6.18-1.63s-3.88-4.88-4.44-5.86l-1.83.65c-2.93,1-5.86,2-8.7,3.1-1,.39-2,.8-3,1.2l1.34-.26c2.73-.24,8.16.91,9.34,3.74a3.63,3.63,0,0,1-2,4.7l-.38.13c-2.07.63-4.52-.44-6.19-1.63s-3.67-4.51-4.33-5.69c-1,.43-2,.9-2.91,1.37-.63.34-1.26.62-1.88,1L646.11,379c-1.14.73-2.32,1.47-3.41,2.2-.76.49-1.48,1-2.21,1.5,1-.43,3-1.11,3.12-1.16,2.67-.67,8.19-.34,9.8,2.27a3.63,3.63,0,0,1-1.32,5,2.91,2.91,0,0,1-.35.18c-2,.95-4.54.26-6.36-.67-2-1-5-4.78-5.39-5.25C638.74,383.84,637.58,384.65,636.5,385.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.09,365.21c2.27-.88,6-4.81,6-4.81s-3.35-1.7-3.57-1.79c-2.61-.93-8.2-1.18-10.11,1.29a3.66,3.66,0,0,0,.83,5.12,1.85,1.85,0,0,0,.33.21C48.5,366.38,51.17,366,53.09,365.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.53,332.62s-1.86-3.26-2-3.46c-1.66-2.2-6.18-5.5-9.12-4.49a3.65,3.65,0,0,0-2.14,4.72,2.43,2.43,0,0,0,.16.37c.92,2,3.37,3.1,5.4,3.54C86.2,333.82,91.52,332.62,91.53,332.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.47,390.14c1.33,1,2.56,2,3.66,3l2.13-.49c-1.39-1.13-3-2.4-4.8-3.75-1-.79-2.19-1.61-3.35-2.45a37.21,37.21,0,0,0,1.62-3.79c2,.22,5.88-.88,6.39-1,.43,1.22.84,2.41,1.21,3.53.85,2.55,1.54,4.82,2.09,6.75l1.72-.4c-.59-1.94-1.35-4.28-2.29-6.87-.44-1.24-.93-2.56-1.44-3.9.45-.26,4.15-2.43,5.3-4.06,1.05-1.48,2-3.67,1.41-5.5a3.22,3.22,0,0,0-4-2.25l-.33.11c-2.53,1.08-3.49,5.91-3.26,8.33,0,.14.33,1.68.56,2.65-.22-.55-.42-1.09-.65-1.64-.44-1.11-.92-2.21-1.43-3.4l-.8-1.7c-.27-.57-.6-1.15-.9-1.73-.72-1.34-1.52-2.66-2.36-4,1-.38,4.44-1.82,5.69-3.13s2.51-3.33,2.25-5.24a3.23,3.23,0,0,0-3.6-2.82l-.33.06c-2.62.69-4.33,5.3-4.46,7.73,0,.16.09,1.91.16,2.87-.5-.78-1-1.56-1.55-2.34-1.55-2.24-3.19-4.45-4.82-6.68-.5-.67-1-1.35-1.49-2,.35-.14,4.46-1.73,5.9-3.22,1.27-1.31,2.52-3.33,2.26-5.24a3.23,3.23,0,0,0-3.59-2.82,1.86,1.86,0,0,0-.34.06c-2.62.68-4.32,5.3-4.45,7.73,0,.19.13,2.72.2,3.35-1.09-1.5-2.16-3-3.14-4.54A57,57,0,0,1,95,344.87c.16,0,4.46-1.73,5.93-3.24,1.27-1.31,2.52-3.32,2.26-5.23a3.24,3.24,0,0,0-3.6-2.83l-.33.06c-2.62.68-4.33,5.3-4.46,7.74,0,.15.09,2.06.17,3l-.15,0a42.39,42.39,0,0,1-2.64-7c-.35-1.31-.6-2.6-.83-3.85.84-.2,4.64-1.32,6.1-2.53s2.87-3,2.79-4.94A3.25,3.25,0,0,0,97,322.91l-.34,0c-2.68.4-4.89,4.8-5.27,7.19,0,.13-.1,1.49-.12,2.47-.09-.56-.2-1.15-.27-1.69-.3-2-.45-3.93-.56-5.61-.06-1-.09-1.81-.11-2.61.7-.66,3.49-3.32,4.22-5s1.15-4,.19-5.67a3.23,3.23,0,0,0-4.37-1.33l-.29.17c-2.22,1.59-2.14,6.52-1.42,8.84,0,.2,1.44,3.22,1.43,3.19h.06c0,.78,0,1.6,0,2.52.08,1.67.19,3.57.44,5.63a56.37,56.37,0,0,0,1.14,6.59,42,42,0,0,0,2.29,7.1l0,.08c-.52-.57-2-2.24-2.17-2.35-1.85-1.59-6.38-3.58-8.68-2.15a3.21,3.21,0,0,0-1,4.45,1.94,1.94,0,0,0,.21.29c1.16,1.54,3.48,2,5.33,2,2.07,0,6.1-1.86,6.42-2a57.93,57.93,0,0,0,3.63,6.71c.78,1.26,1.61,2.5,2.45,3.74a13.71,13.71,0,0,1-.93-1c-1.85-1.6-6.35-3.58-8.68-2.16a3.23,3.23,0,0,0-1,4.46l.21.29c1.16,1.53,3.48,2,5.33,2s5.32-1.52,6.24-1.93l1,1.42c1.59,2.26,3.18,4.5,4.66,6.75.53.8,1,1.6,1.52,2.43-.41-.45-.77-.83-.83-.88-1.85-1.59-6.38-3.57-8.67-2.15a3.22,3.22,0,0,0-1,4.46l.21.29c1.16,1.53,3.49,2,5.33,2s5-1.36,6.08-1.85c.48.84,1,1.67,1.38,2.5.28.57.59,1.11.84,1.69s.51,1.16.77,1.73c.44,1.11.91,2.26,1.32,3.35.29.76.55,1.49.82,2.23-.52-.8-1.56-2.33-1.66-2.45a12.54,12.54,0,0,0-5.42-3.46,3.45,3.45,0,0,0-.51-.5,3.24,3.24,0,0,0-4.56.32l-.21.27c-1.49,2.29.35,6.86,1.88,8.75.1.11,1.2,1.21,1.93,1.9-.49-.34-.95-.68-1.46-1.05-1-.68-2-1.34-3.07-2.07l-1.61-1c-.53-.35-1.13-.63-1.71-.95-1.34-.71-2.73-1.38-4.15-2,.61-.84,2.67-4,3-5.76s.27-4.16-1-5.59a3.24,3.24,0,0,0-4.56-.37l-.25.24c-1.83,2-.69,6.82.52,8.9.08.13,1.13,1.54,1.73,2.31-.86-.38-1.71-.76-2.59-1.1-2.53-1-5.12-2-7.71-2.91l-2.35-.8c.21-.31,2.76-3.94,3.14-6,.33-1.78.27-4.16-1-5.58A3.22,3.22,0,0,0,78.8,362a1.84,1.84,0,0,0-.25.23c-1.82,2-.7,6.82.53,8.9.09.16,1.6,2.19,2,2.68-1.74-.65-3.45-1.32-5.13-2.05a56.23,56.23,0,0,1-6.57-3.33c.1-.14,2.78-3.91,3.16-6,.35-1.79.27-4.17-1-5.59a3.24,3.24,0,0,0-4.56-.37l-.25.24c-1.82,2-.69,6.81.53,8.9.08.13,1.23,1.68,1.8,2.4l-.11.12a42.18,42.18,0,0,1-5.9-4.5c-1-.9-1.94-1.83-2.82-2.75.55-.65,3.15-3.66,3.7-5.48s.72-4.1-.41-5.66a3.22,3.22,0,0,0-4.48-.87,1.78,1.78,0,0,0-.27.21c-2,1.82-1.45,6.7-.46,8.93,0,.13.74,1.29,1.25,2.13-.39-.41-.8-.84-1.17-1.25-1.37-1.54-2.53-3-3.55-4.37-.58-.76-1.08-1.46-1.55-2.12.23-.93,1.09-4.7.76-6.53s-1.26-4-3-4.86a3.24,3.24,0,0,0-4.39,1.3,2.92,2.92,0,0,0-.14.31c-1,2.55,1.81,6.61,3.72,8.16.17.13,3,1.89,3,1.84l0-.05c.44.65.92,1.33,1.45,2.06,1,1.36,2.12,2.89,3.47,4.46a55.66,55.66,0,0,0,4.6,4.87,41.74,41.74,0,0,0,5.84,4.68l.08,0c-.74-.22-3-.75-3.11-.77-2.42-.31-7.27.52-8.43,3a3.23,3.23,0,0,0,1.64,4.26,3.82,3.82,0,0,0,.36.13c1.82.64,4-.24,5.55-1.22,1.71-1.14,4.06-4.91,4.25-5.21a56.33,56.33,0,0,0,6.72,3.61c1.34.62,2.71,1.21,4.1,1.77l-1.36-.32c-2.41-.31-7.27.52-8.42,3a3.22,3.22,0,0,0,1.65,4.26l.35.13c1.82.63,4-.24,5.54-1.23s3.61-4.2,4.15-5.05l1.6.64c2.57,1,5.13,2,7.65,3.08.88.37,1.73.77,2.58,1.16-.59-.15-1.1-.26-1.18-.27-2.41-.31-7.26.52-8.42,3a3.23,3.23,0,0,0,1.65,4.26l.35.13c1.81.63,4-.24,5.55-1.23s3.4-3.9,4-4.9c.87.43,1.72.86,2.54,1.32.55.32,1.1.59,1.61.95l1.62,1c1,.68,2,1.37,3,2.09.67.47,1.29.93,1.91,1.4-.86-.38-2.58-1.08-2.73-1.13-2.34-.67-7.26-.59-8.78,1.68a3.22,3.22,0,0,0,1,4.45l.3.17c1.7.9,4,.39,5.67-.37,1.81-.85,4.6-4.07,5-4.49C107.57,388.64,108.55,389.41,109.47,390.14Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.91,49.14c-59.07-35-137.66-22.66-193,19.31-39.59,30-76.34,65-121.52,85.68C206.65,170,167,177.64,141.06,207.79c-40.55,47.2-35.15,113.73-7,165.7,32.68,60.31,92,87.41,158.11,96,65.87,8.59,135.25-1.28,193.05-35.19,77-45.18,118.29-131.53,133-217C629.26,152.92,615.73,84.55,555.91,49.14Z",
    style: {
      fill: "#FF2934"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.91,49.14c-59.07-35-137.66-22.66-193,19.31-39.59,30-76.34,65-121.52,85.68C206.65,170,167,177.64,141.06,207.79c-40.55,47.2-35.15,113.73-7,165.7,32.68,60.31,92,87.41,158.11,96,65.87,8.59,135.25-1.28,193.05-35.19,77-45.18,118.29-131.53,133-217C629.26,152.92,615.73,84.55,555.91,49.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Interface--inject-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--capa-6--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.15,96.46V424.12a15.32,15.32,0,0,1-15.33,15.32H128.66a15.32,15.32,0,0,1-15.32-15.32V96.46c0-.22,0-.44,0-.65a15.32,15.32,0,0,1,14.52-14.66l.78,0H616.82l.79,0a15.32,15.32,0,0,1,14.52,14.66C632.14,96,632.15,96.24,632.15,96.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.13,95.81H113.36a15.32,15.32,0,0,1,14.52-14.66l.78,0H616.82l.79,0A15.32,15.32,0,0,1,632.13,95.81Z",
    style: {
      fill: "#FF2934",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9,88.47a2.4,2.4,0,1,1-2.4-2.4A2.39,2.39,0,0,1,139.9,88.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.36,88.47a2.4,2.4,0,1,1-2.4-2.4A2.39,2.39,0,0,1,149.36,88.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.83,88.47a2.41,2.41,0,1,1-2.41-2.4A2.4,2.4,0,0,1,158.83,88.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 139.52,
    cy: 242.73,
    r: 12.31,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.82 235.46 135.74 242.73 141.82 248.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--progress-bar--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.56,402.19a6.27,6.27,0,0,0,1.19,4.88c1.78,2.39,3.41,2.69,3.41,2.69v10.5s-9.35,1.82-11.58.49c-1.51-.91-1.45-5.66-1.25-8.61a2.75,2.75,0,0,1,2.53-2.57l3-.25S386.14,401,389.56,402.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.55,
    y: 409.32,
    width: 3.41,
    height: 11.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.59,416.29v.88a2.31,2.31,0,1,1-4.61,0v-.28l1.39-.14v.32c0,.76.33,1.09.89,1.09s.88-.33.88-1v-1c0-.76-.33-1.09-1.09-1.09h-.57v-1.36H406c.76,0,1.09-.33,1.09-1.09v-.74a.76.76,0,0,0-.82-.86c-.52,0-.82.3-.82,1v.21H404V412a2.24,2.24,0,1,1,4.47,0v.62a2.14,2.14,0,0,0,.1,3.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.75,417.22V412a2.32,2.32,0,0,1,4.63,0v5.21a2.32,2.32,0,0,1-4.63,0Zm3.18,0V412a.87.87,0,1,0-1.74,0v5.21a.87.87,0,1,0,1.74,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.53,415.46l-.55,1.05v2.87h-1.44v-9.53H420v3.87l1.91-3.87h1.55l-2,4,2.18,5.49H422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.19,426.51a6.32,6.32,0,0,1,1.19-4.88c1.78-2.4,3.42-2.69,3.42-2.69v-10.5s-9.36-1.83-11.58-.49c-1.52.91-1.45,5.66-1.26,8.61a2.76,2.76,0,0,0,2.54,2.57l3,.25S442.78,427.7,446.19,426.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.68,
    y: 408.25,
    width: 3.41,
    height: 11.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.73,411.9h-1.64v-1a2.41,2.41,0,0,0,2.07-1.05h1v9.54h-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.06,418h2.86v1.37h-4.57v-1.26l2.11-3.36a4.79,4.79,0,0,0,1-2.65c0-.66-.31-1-.87-1s-.87.37-.87,1v.56h-1.39v-.45a2.2,2.2,0,0,1,2.27-2.5,2.14,2.14,0,0,1,2.3,2.35,6,6,0,0,1-1.28,3.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473,417.2v-.29l1.39-.14v.32c0,.76.33,1.06.86,1.06s.86-.3.86-.93V415c0-.56-.3-.84-.76-.84a.87.87,0,0,0-.9.94v.17H473v-5.45h4.13v1.36h-2.74v2.37a1.56,1.56,0,0,1,1.38-.69,1.7,1.7,0,0,1,1.72,1.92v2.4a2.28,2.28,0,1,1-4.55,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.78 420.14 268.78 412.8 272.52 412.8 278.22 407.25 278.22 424.64 273.5 419.84 268.78 420.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,416a5.53,5.53,0,0,1-3.46,5.14V410.81A5.53,5.53,0,0,1,283.77,416Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.74,407.24a8.84,8.84,0,0,1,.55,17.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,424.15h0a1.63,1.63,0,0,1-1.63-1.63V410.43a1.63,1.63,0,0,1,1.63-1.63h0a1.63,1.63,0,0,1,1.63,1.63v12.09A1.63,1.63,0,0,1,206.68,424.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.19,424.15h0a1.63,1.63,0,0,1-1.63-1.63V410.43a1.63,1.63,0,0,1,1.63-1.63h0a1.63,1.63,0,0,1,1.63,1.63v12.09A1.63,1.63,0,0,1,213.19,424.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.23,409h0a1.65,1.65,0,0,1,1.64,1.64v12.19a1.64,1.64,0,0,1-1.64,1.64h0a1.63,1.63,0,0,1-1.64-1.64V410.59A1.64,1.64,0,0,1,174.23,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,410.26V423a.67.67,0,0,1-1.08.53l-8.44-6.68a.67.67,0,0,1,0-1.07l8.44-6.1A.67.67,0,0,1,186.4,410.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,423.78h0a1.65,1.65,0,0,1-1.62-1.66l.15-12.19a1.63,1.63,0,0,1,1.66-1.62h0a1.63,1.63,0,0,1,1.62,1.66l-.14,12.19A1.66,1.66,0,0,1,245.46,423.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.31,422.32l.15-12.78a.67.67,0,0,1,1.09-.51l8.36,6.78a.67.67,0,0,1,0,1.06l-8.51,6A.67.67,0,0,1,233.31,422.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.79,
    y: 374.85,
    width: 302.93,
    height: 20.77,
    rx: 8.91,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.89,385.2a2.31,2.31,0,0,1-2.33,2.33H180.07a2.33,2.33,0,0,1,0-4.66H457.56A2.33,2.33,0,0,1,459.89,385.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.23,382.87l-.16,4.66h-70a2.33,2.33,0,0,1,0-4.66Z",
    style: {
      fill: "#FF2934"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.28,384.73a6.35,6.35,0,1,1-6.35-6.35A6.35,6.35,0,0,1,255.28,384.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.49,384.65a2.58,2.58,0,1,1-2.58-2.57A2.58,2.58,0,0,1,251.49,384.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481,146.4V342.56a14.76,14.76,0,0,1-14.75,14.75H181.54a14.75,14.75,0,0,1-14.75-14.75V146.4a13.2,13.2,0,0,1,.18-2.29,14.76,14.76,0,0,1,14.57-12.46H466.2a14.78,14.78,0,0,1,14.57,12.46A14.26,14.26,0,0,1,481,146.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.16,
    y: 108.03,
    width: 101.09,
    height: 10.71,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.58,258.79s5,19.56,13.63,31.63c11.78,11,19.21,11.61,28.2,11.61s13.32-4.51,13.32-4.51l1.55-10.65-4.65-16.46s-16.42-18.72-22.31-23.56-18.58-19.36-22.3-38.08-9.61-27.43-9.61-27.43-2.08-18.42-4.82-18.18-5.71,10.47-5,17c0,0-7.19-5.23-9.36-7.25s-10.62-11.78-12.11-10.47S202.64,177,210,183.14c0,0-5.59-.83-9.13-4.4s-10.28-10.94-13.36-9.63a3.78,3.78,0,0,0-2.4,4.28s-3.31,1-2.28,6.07c0,0-3.09,4.52,1.25,10.94s12.79,13,20.33,16.53,10.61,5.71,13.35,12S232.58,258.79,232.58,258.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.27,286.87l-1,6.79-.56,3.86S283.39,302,274.41,302s-16.43-.65-28.2-11.63c-8.65-12.07-13.63-31.62-13.63-31.62S220.45,225.26,217.72,219s-5.83-8.44-13.37-12-16-10.12-20.32-16.54c-2.94-4.35-2.48-7.83-1.87-9.62a6.6,6.6,0,0,1,.61-1.32c-1-5.12,2.29-6.07,2.29-6.07a3.78,3.78,0,0,1,2.4-4.27c3.08-1.32,9.82,6,13.35,9.62s9.14,4.41,9.14,4.41c-7.31-6.2-12.33-19.4-10.85-20.7s9.94,8.45,12.1,10.47,9.37,7.25,9.37,7.25c-.69-6.53,2.28-16.76,5-17s4.82,18.18,4.82,18.18,5.88,8.71,9.59,27.42,16.43,33.25,22.31,38.09,22.31,23.56,22.31,23.56Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.16,242.39s12.11-17,14.13-22,11.2-20.26,21.11-21.41a68,68,0,0,0,18.54-5.17l52.69,3.06s11.12,4.16,21.22,8c9.52,3.62,20.12,9.68,20.45,19.16.29,8.29,16.1,38.5,27.17,48L391,285.25s-1.51,12.62-8.23,17.66c0,0,14.71,34.38,8.65,54.84l-119.62-.43s-4.69-46.9,16.05-63.35c0,0-5.4-12-5.77-22.52C282.1,271.45,278.43,261.51,259.16,242.39Z",
    style: {
      fill: "#FF2934"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.28,293.66l-4.6,4.88s-1.9,3-9.92,3.24c-9,.29-15.78-.39-27.55-11.37-8.65-12.07-13.63-31.62-13.63-31.62S220.45,225.26,217.72,219s-5.83-8.44-13.37-12-16-10.12-20.32-16.54c-2.94-4.35-2.48-7.83-1.87-9.62,3.6,2,7.86,5.52,11,7.81,6.2,3.74,10.51,6.64,16.83,10.08,12.54,6.85,19.11,21.43,23.87,35.32s9,28.8,19.3,38.92a48.39,48.39,0,0,0,21.2,11.74c4.72,1.28,10.08,2.36,12.81,6.55A9.28,9.28,0,0,1,288.28,293.66Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,302.91c.87.3,16.21,34.91,8.65,54.84l-66.85-.43-53.8-.66s-3.2-46.37,17.54-62.81c0,0-6-12-6.37-22.56,0,0-3.5-9-22.78-28.16,0,0,11.93-18,13.94-22.95s10.67-19.71,20.59-20.86a50.82,50.82,0,0,0,18.19-6.16l52.69,3.06a68.78,68.78,0,0,0,10.78,5.06c3.26,1.19,6.79,1.88,10.27,3.2,13.24,5,19.52,10.67,20.62,18.9s16.1,38.5,27.16,48l-43.87,15.1S387.74,298.88,382.79,302.91Z",
    style: {
      fill: "#FF2934"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,302.91s15.81,29.83,8.65,54.84l-66.85-.43c-1.33-4.18-1.33-9.1-1-13.47-1.35-2.55-.35-5.69-.24-8.61.17-4.51-1.9-8.76-4.17-12.59s-4.87-7.61-6-12-.27-9.62,3.22-12.31c3.88-3,9.27-1.72,14-.62,7.74,1.83,15.78,2.91,23.59,1.44s15.38-5.74,19.58-12.73a14.29,14.29,0,0,0,2-5.1,20.82,20.82,0,0,0-.38-6.76c-1.14-6.64-2.53-13.34-1.88-20.05.43-4.41,1.73-8.68,2.3-13.08a39.63,39.63,0,0,0-6.23-26.9c2.8-3.69,3.51-9.29,6-13.13,3.26,1.19,6.95,2.42,10.56,3.34,10.47,2.67,20.26,10.51,21.36,18.73s12.43,34.86,26.42,48.36l-42.77,12.93S389.9,297.92,382.79,302.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.94,271.85s3.1-3.8,6-3c0,0,6.93,9.31,9.85,12.73,2.36,2.77,4.49,9.16,3.85,14.72a7.44,7.44,0,0,1-3.3,5.36c-3.74,2.47-11.31,6.78-18.23,6.5-9.67-.38-25.89-8-31.54-19.94s-6.93-27.53-6.93-27.53-7.47-8.17-6.38-16.14,6.07-18.85,7.23-22,2.61-7.48,4.62-6.91,4.66,7.61.65,19.39c0,0,3.36,0,5.91-4.2s10.43-22.72,15.37-17c0,0,4.54-3.15,6.45-.06,0,0,3.42-2.27,3.52.7.15,4.38-1.29,14.86-1.29,14.86s3.62-2.72,3.62,3.36-2.1,17.07-9.93,23.72C415.42,256.44,419.56,266.54,425.94,271.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.65,296.26a7.46,7.46,0,0,1-3.34,5.4c-3.52,2.31-10.37,6.21-16.89,6.46h-1.3c-9.66-.37-25.89-8-31.54-19.93s-6.93-27.54-6.93-27.54-7.47-8.17-6.39-16.15,6.08-18.83,7.24-21.95,2.61-7.48,4.62-6.9,4.67,7.6.65,19.38c0,0,3.35,0,5.91-4.2s10.44-22.73,15.37-17c0,0,4.54-3.15,6.45-.06,0,0,3.41-2.27,3.52.7.15,3.86-1,12.47-1.24,14.45h0c0,.26,0,.4,0,.4s3.62-2.72,3.62,3.36-2.09,17.07-9.94,23.71c0,0,4.15,10.11,10.53,15.43,0,0,2.19-3.18,5.19-3.14,0,0,7.75,9.4,10.67,12.82C444.16,284.3,446.29,290.7,445.65,296.26Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82,150l11.25-12.28-.54-15.62-9.91-7.26L306.27,96.47l-21.16,35.71s7.23,43.8,13.39,48,5.63,16.74,5.63,16.74,8.08,31.21,36.2,33.44c26,1.72,34.91-29,34.91-29s-15.44-5.47-18.65-14.12S355.82,150,355.82,150Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.47,201.41s-1.78,4-4.27,9.08l0,0c-4.32,8.86-13.39,20.78-30.69,19.91-28.14-2.23-36.37-33.87-36.37-33.87s.55-12.56-5.61-16.74-13.4-48-13.4-48l21.16-35.71,21.08,7.7,29.27,10.72,9.92,7.24.53,15.64-11.26,12.27s3.45,27.66,2.15,36.83C356.78,194.89,375.47,201.41,375.47,201.41Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-12)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.3,201.48s-1.61,3.9-4.1,9l0,0-1,1.91c-17.28-12.49-25.37-31.77-26.09-53.73-.08-2.23,1.84-29.89,2.74-29.87-26-.4-41.48-25.83-41.48-25.83l22,.82,29.27,10.72,9.92,7.24.53,15.64-11.26,12.27s.22,27.78,2.15,36.83C359.72,194.73,375.3,201.48,375.3,201.48Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.23,130.89s3.66-9.87,11.18-8,4,22.06-2.65,24-7.11-4-7.11-4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,132.73c0-.2,0-.4,0-.61.12,2.28.63,4.52.65,6.8s-.53,4.7-2.15,6.24c-1.06,1-2.64,1.75-2.86,3.24a4,4,0,0,0,.6,2.32,9.71,9.71,0,0,0,2.26,3.06,4.25,4.25,0,0,0,3.47,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.77,164s15.72-3.42,19.31-14.58c0,0,2.53,11.86-4.59,16.81C319.5,171.77,312.77,164,312.77,164Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,120.57c1.8,14.26,3.18,28.46,7.51,42.23,3,9.46,9.45,18.77,20.19,18.15,13-.76,22.91-3,31.42-13.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.89,124.72s4.71-4.7,10.71-.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.74,126.39c-2.35-1-6.32-1.54-10,3.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.82,180.67s.52,14.89-4,17.25-22.47-3.15-32.07,6.32-20.37,34.59-25.67,38.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.85,135.23c0,2.13-.76,3.86-1.71,3.86s-1.72-1.73-1.72-3.86.77-3.87,1.72-3.87S326.85,133.09,326.85,135.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.86,137.34c0,2.13-.76,3.86-1.71,3.86s-1.72-1.73-1.72-3.86.77-3.86,1.72-3.86S304.86,135.2,304.86,137.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.21,126.52s6.88-1.8,14.41-23.52c0,0,21.33,27.59,44.25,24.08,0,0,6.36-7.73,11.93-2,4.67,4.8,0,20-3.89,21.39s-5.21.08-5.21.08-11,20.92-.08,38.6,33.93,8.16,41.33-5.44.22-24.47.22-24.47,5.22,2.26,5.43,9.29c0,0,4.36-7.71-2.17-18.58s-13.6-21.77-20.19-32.79c-6.38-10.65-11.13-24.79-22.94-30.49-13.82-6.66-31.08-4.83-44.89.79C298,88.12,292.17,99.24,287.6,110.57c-3.24,8-5.08,16.63-8.5,24.6-3,7-8.33,12.45-11.37,19.46-8.16,18.8-.61,40.75,16.78,49.6,0,0,1.54-3.88,8.72-4.56s8.7-1.36,15.44-1.13,8.92-.45,10.44-4.53,2-12.95,2-12.95S312.3,183,306,177.48C299.73,170,297.49,166,296,156.75S291.21,126.52,291.21,126.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.11,181.06s-1.29,8.55,8,6.07,19.4-18.44,19.4-18.44S337.28,179.76,321.11,181.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,357.16s-6.44-41.74,16.95-63.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.4,295.09c-8.22-12.76-11.3-34.72.64-46.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.52,172.59s2,22,28.33,29.51c21.11,6,25.92,12.82,27.26,15.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,198s10.69,32.42,39.18,32.85c20.8.32,31.53-29.11,31.53-29.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,298c14.87,6.38,31.37,6.89,47.45,7.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,299.52c-1.46,1.1-4.41,1.63-5.11,1.75-13.16,2.21-25.46-2.14-33.52-13.38-4.49-6.26-6.7-13.33-9.07-20.68-5.25-16.28-10.74-32.37-17-48.25,0,0-1.8-4.08-3.72-5.68-3.41-2.83-10-7.49-15.06-8.94-7.24-2.08-20.24-18-18-22.39s14,10.67,19,12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.09,239.62s-1.27-13.5,3.31-25.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.42
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.43,92.92s11.79,20.46,32.42,22.51",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.67,148.19a64.81,64.81,0,0,0,5.61,40",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.77,107.17c6.7,6.12,13.19,12.63,16.4,21.17,3,7.93,2.76,16.71,3,25.23S378.21,171,382.87,178",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.27,86.59q7,7.3,14.46,14.19",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.75,142.57a54,54,0,0,0-4.57,40.87",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.11,205s29.7-44.84,26.55-47.56S200,202,200,202s-7.88,1.52-11.27,4.84-11.33,24-10.32,24.69,11.09-16.48,12-16.26-5.6,20.59-4.68,20.82,11.54-17.76,13-17.2-6.85,20.24-5.47,20.58,13.86-17.64,14.07-21.54S206.11,205,206.11,205Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.05,231.16a25.36,25.36,0,0,0,5.41-5.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,234.09s9.63,3.77,19.24,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.66,240.61s-7.25-5.12-15-3.9c0,0,6.08-19.5,1.4-21-3.18-1-4.81,4.64-5.59,6.8-1.52,4.22-3.37,8.17-5,12.34-3,7.63-2.46,18.47,3.81,24.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,257.38c3.37-3,6.86-6.17,8.66-10.4a29.49,29.49,0,0,0,1.81-7.39c.37-2.48.68-5,.95-7.46a3.17,3.17,0,0,0-.49-2.58,1.89,1.89,0,0,0-2.12-.25,4.87,4.87,0,0,0-1.68,1.55,20.39,20.39,0,0,0-3,5.72c-.74,2.15-1.13,4.47-2.31,6.39-.1.17-.21.33-.32.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.49,231.55c2-5.76,2.57-12.36,2.56-18.48a4.16,4.16,0,0,0-3.73,1.39,12.4,12.4,0,0,0-2.2,3.61c-2.78,6.15-5.07,12.6-8.3,18.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.82,213.45c-.54-1.49-2.5-1.93-3.9-1.29a7.73,7.73,0,0,0-3.11,3.4c-3.42,5.94-5.47,12.64-8.64,18.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.13,214.82c.28-1.41-1.34-2.6-2.71-2.36a5.59,5.59,0,0,0-3.26,2.53c-2.79,3.81-4.55,8.31-7,12.35s-4.63,7.33-9.13,8.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.26,258.16s2.7,16,5.12,24.73c2.36,8.47,21.56,36.34,51.64,19.51a7.48,7.48,0,0,0,3.67-5.15,18.68,18.68,0,0,0-3.26-14.36c-6.47-9.28-19.95-22.48-22.92-30.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.09,256.83a32.21,32.21,0,0,0,5.85,9.88c3.05,3.5,6.8,6.25,10.06,9.55s6.1,7.39,6.55,12.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.78,284.94s-.72,16.22-13,21.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,302.91s15.89,27.31,8.65,54.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,180.48s-1.77-4.85,1-6.68,16.74,13.28,20.49,13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.22,173.78a3.25,3.25,0,0,1,1.65-4,4.88,4.88,0,0,1,4.48.44,16.5,16.5,0,0,1,3.55,3.14c4.73,5,9.5,9.35,16.22,10.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.45,183.12s-12.8-12.39-11.9-19.17,9.41,10,17.71,13.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,183.63c-.46-1.48-1.09-3.12-1.43-4.71-.54-2.56-.81-5.18-1.14-7.78-.23-1.81-.63-9.28-4-7.18-5.32,3.33-3.72,22.17-3.72,22.17-6.38,3.88-7.71,13-7.71,13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,183.7a26.14,26.14,0,0,1-1.43-4.86c-.54-2.57-.81-5.19-1.14-7.79-.23-1.81-.63-9.28-4-7.18-5.32,3.33-3.72,22.17-3.72,22.17-6.38,3.88-7.71,13-7.71,13",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09,182.7a21.39,21.39,0,0,1-1.52-4.32c-.55-2.56-.81-5.18-1.15-7.78-.23-1.81-.62-9.28-4-7.18-5.32,3.33-3.73,22.17-3.73,22.17-6.38,3.88-7.71,13-7.71,13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.71,270.13c-2.55-9.31-28.71-28.13-37.2-47.44-2.36-5.37-3.64-11.31-5.22-16.95a201.15,201.15,0,0,0-7-20.23c-.39-1-.82-1.9-1.23-2.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.31,301.66c-3.52,2.31-10.37,6.21-16.89,6.46a52.72,52.72,0,0,1-5.69-4.15c-11.42-9.54-19.43-24.29-18.69-39.52a19.21,19.21,0,0,1,2.55-9.48c2.77-4.35,7.76-6.35,10.79-10.43,3.46-4.67,3.44-11,7.4-15.58,0,.26,0,.4,0,.4s3.62-2.72,3.62,3.36-2.09,17.07-9.94,23.71c0,0,4.15,10.11,10.53,15.43a8.28,8.28,0,0,1,5.06-3.24s7.88,9.5,10.8,12.92c2.36,2.76,4.49,9.16,3.85,14.72A7.46,7.46,0,0,1,442.31,301.66Z",
    style: {
      fill: "#263238",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.21,254.26c0-.7,13.72-15.27,17.28-30.59,0,0-.34,15.16-.53,17.66,0,0,0,.54,0,.72.29,8.22,1.12,9.66,1.12,9.66s-5.13,11.84-5.13,16.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.38,357.49c1.82-5.41,3.37-34.89-.52-39.49s-76.73-6.52-78.92.55c-2.67,8.64,1.73,38.89,1.73,38.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,331.43a8.34,8.34,0,0,1,9.35-2.31c3.67,1.48,4,6.65,3,10.09-1.53,5.36-6.32,12.84-12.5,12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.9393370151519775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,313.61a7.21,7.21,0,0,0,2-5.13,13,13,0,0,0-1.6-6.71,18.65,18.65,0,0,0-1.79-2.62c-.7-.89-1.44-1.75-2.21-2.58-.09-.1-.26-.1-.32-.22s.22-.12.12-.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.15,286.07a20.57,20.57,0,0,0,8.11-19.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.75,255.39s-2.86-8-9-11.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,357.59c1.81-5.41,3.37-34.89-.52-39.49s-76.73-6.52-78.92.54c-2.68,8.64,1.73,38.9,1.73,38.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.38,357.49c1.82-5.41,3.37-34.89-.52-39.49s-76.73-6.52-78.92.55c-2.67,8.64,1.73,38.89,1.73,38.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,318.4c0,.6-15.92,1.09-35.55,1.09S268.7,319,268.7,318.4s15.91-1.09,35.55-1.09S339.8,317.8,339.8,318.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.35,255.89a10.42,10.42,0,0,1,5.28,8.48,10.58,10.58,0,0,1-4.29,9.06c-3.67,2.58-8.45,2.3-12.84,2.92s-9.36,3.13-9.83,7.72a9.88,9.88,0,0,0,2.13,6.5c2.17,3.11,5.14,5.51,7.79,8.19s5.09,5.87,5.74,9.65-1,8.24-4.53,9.5c2.18,0,4.41.21,6.59.21,4.3,0,5.84-6.89,5.43-11.35a16.75,16.75,0,0,0-6.38-11.25c-1.72-1.39-3.7-2.51-5.07-4.28s-1.93-4.52-.54-6.27c1.74-2.18,5-1.45,7.74-1.64,5.71-.4,10.28-6.12,10.59-12.07S321,259.38,316.35,255.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.9797790050506592px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Videos--inject-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 135.94,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 147.91,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 159.88,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.14,
    y: 124.27,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.41,
    y: 119.01,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      fill: "#FF2934",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.05,
    cy: 153.48,
    r: 23.11,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.49 166.83 480.49 141.31 500.77 154.07 480.49 166.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 226.38,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 238.34,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 250.31,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.14,
    y: 212.91,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.41,
    y: 208.03,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      fill: "#FF2934",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.05,
    cy: 242.73,
    r: 23.11,
    transform: "translate(-55.59 201.73) rotate(-22.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.49 256.08 480.49 230.56 500.77 243.32 480.49 256.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 314.73,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 326.7,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 338.67,
    width: 62.32,
    height: 6.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.14,
    y: 301.03,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.41,
    y: 297.06,
    width: 109.18,
    height: 68.31,
    rx: 8.91,
    style: {
      fill: "#FF2934",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.05,
    cy: 331.98,
    r: 23.11,
    transform: "translate(-89.62 209.98) rotate(-22.33)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.49 345.34 480.49 319.81 500.77 332.57 480.49 345.34",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b45bd9881c5c2ef311213ca9d9345ccf.svg";
export { ForwardRef as ReactComponent };